<div class="st-section-filter__header">
    <span class="st-section-filter__header__title">{{ languageSettings()?.PSTWebSectionFilterFilterLabel }}</span>
    <div class="st-section-filter__header__actions">
        <button
            mat-icon-button
            [disabled]="disabled()"
            (click)="onSave()">
            <mat-icon fontSet="material-symbols-outlined">save</mat-icon>
        </button>
        <button
            mat-icon-button
            [disabled]="disabled()"
            (click)="onRevert()">
            <mat-icon>refresh</mat-icon>
        </button>
        <button
            mat-icon-button
            [disabled]="disabled()"
            (click)="onClear()">
            <mat-icon fontSet="material-symbols-outlined">filter_list_off</mat-icon>
        </button>
    </div>
</div>

<div class="st-section-filter__body">
    @for (filter of mergedFilters(); track filter.ID; let last = $last) {
        <section class="st-section-filter__section">
            <div class="st-section-filter__section__title">{{ filter.DefaultCaption }}</div>
            <div class="st-section-filter__section__body">
                @switch (filter.DisplayType) {
                    @case ('checklist') {
                        <st-check-list
                            [label]="languageSettings()?.PSTWebPlusButtonLabel"
                            [value]="filter.Value"
                            [itemList]="filter.Options"
                            [disabled]="disabled()"
                            (changed)="onChange($event, filter)"
                            (selectionChange)="onSelectionChange($event, filter)" />
                    }
                    @case ('staffidlist') {
                        <st-staff-id-list-multiple
                            [label]="languageSettings()?.PSTWebPlusButtonLabel"
                            [value]="filter.Value"
                            [disabled]="disabled()"
                            [includeBlank]="true"
                            [includeMe]="true"
                            (changed)="onChange($event, filter)" />
                    }
                    @case ('checkbox') {
                        <mat-button-toggle-group
                            hideSingleSelectionIndicator
                            class="st-section-filter__toggle-group"
                            [value]="filter.Value"
                            [disabled]="disabled()"
                            (change)="onToggleChange($event, filter)">
                            @for (opt of filter.Options; track opt.id) {
                                <mat-button-toggle [value]="opt.id">{{ opt.title }}</mat-button-toggle>
                            }
                        </mat-button-toggle-group>
                    }
                    @case ('lookuplist') {
                        <st-tags-autocomplete
                            [value]="filter.Value"
                            [label]="filter.DefaultCaption"
                            [disabled]="disabled()"
                            [includeBlank]="true"
                            (changed)="onChange($event, filter)" />
                    }
                }
            </div>
        </section>
        @if (!last) {
            <mat-divider class="st-section-filter__divider" />
        }
    }
</div>
